// @flow
import {connect} from 'react-redux'

import Header from '../components/Header'

import type {MapStateToProps} from 'react-redux'
import type {State} from 'modules/Common/types'
import type {RouterHistory} from 'react-router'

export type OwnProps = {
  history: RouterHistory,
  location: {
    pathname: string
  }
};

export type StateProps = {};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (state: State) => {
  return {}
}

export default connect(mapStateToProps, null)(Header)
